export default (dirty, ...args) => (
  (global.DOMPurify && global.DOMPurify.sanitize(dirty, ...args)) || dirty
);
